export default "__VITE_ASSET__bn5ZY10v__"